<template>
  <div class="mainDiv">
    <div class="image">
      <img
        width="460px"
        height="420px"
        class="imageMobile"
        src="../../../assets/LandingPage/ReachUsForm/reachusImage.png"
        alt=""
      />
    </div>

    <div class="formDiv">
      <div>
        <img
          class="backgroundimage"
          style=""
          src="../../../assets/LandingPage/headerBackground.png"
        />
      </div>
      <div class="formmainDiv">
        <p class="headerText">Reach out to us!</p>
        <v-form @submit.prevent ref="contactUsFormRef">
          <v-text-field
            outlined
            class="textField"
            placeholder="Name *"
            v-model="querryForm.name"
            pattern="[A-Za-z]*"
            required
            :rules="appliedRules"
          ></v-text-field>
          <v-text-field
            outlined
            class="textField"
            placeholder="Contact number *"
            v-model="querryForm.phone_number"
            maxlength="10"
            type="number"
            pattern="[0-9]*"
            inputmode="numeric"
            :rules="phonenumberRule"
            required
          ></v-text-field>

          <v-text-field
            outlined
            class="textField"
            placeholder="Email ID *"
            v-model="querryForm.email"
            type="email"
            :rules="emailRules"
            required
          ></v-text-field>
          <v-text-field
            outlined
            class="textField"
            placeholder="Brand Name *"
            v-model="querryForm.brand_name"
            :rules="appliedRules"
            pattern="[A-Za-z]*"
            required
          ></v-text-field>
          <v-text-field
            outlined
            class="textField"
            placeholder="Any specific query? Or write a message for us here..."
            v-model="querryForm.query"
            required
            height="72px"
            background-color="#f8f9f8"
          ></v-text-field>
        </v-form>
        <div class="buttonDiv">
          <v-btn
            class="buttonDiv"
            height="54px"
            color="#339137"
            style="cursor: pointer"
            @click="requestDemoButton()"
            ><p class="submitButtonText">Request a demo</p></v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MoengageEventGenerator from "../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../helpers/moengageEvents";
import MoengageAtrributes from "../../../helpers/moengageAttributes";
import API_URL from "../../../helpers/apiUrls";
import rules from "../../../helpers/rules";

export default {
  name: "ReachOutToUs",
  data() {
    return {
      //emailRules: rules,
      rules: rules,
      appliedRules: [],
      phonenumberRule: [],
      emailRules: [],
      querryForm: {
        name: "",
        phone_number: "",
        email: "",
        brand_name: "",
        query: "",
      },
    };
  },

  //Api call for request button

  methods: {
    gtagEventHandler(eventName, attributeValue) {
      this.$gtag.event(eventName, attributeValue);
    },
    requestDemoButton() {
      //contactUsFormRef
      this.appliedRules.push(this.rules.required);
      this.phonenumberRule.push(this.rules.validPhoneNumber);
        this.emailRules.push(this.rules.validEmail);
     // alert(this.$refs.contactUsFormRef.validate())
      if (this.$refs.contactUsFormRef.validate()) {
        const moengageAttr = {
          [MoengageAtrributes.IsUserGenerated]: "TRUE",
          [MoengageAtrributes.ButtonClicked]: "Request A Demo Form Button",
          [MoengageAtrributes.Device]: !this.isMobile ? "Desktop" : "Mobile",
          [MoengageAtrributes.Platform]: "Web",
          [MoengageAtrributes.Source]: "BSLandingPage",
          [MoengageAtrributes.NextActivity]: "Form Submitted",
        };
        MoengageEventGenerator(MoengageEvents.LandingPageAction, moengageAttr);
        this.gtagEventHandler(MoengageEvents.LandingPageAction, moengageAttr);

        const successHandler = (response) => {
          if (response.status === 201) {
            this.loader = false;

            this.showToast(
              "Your request for demo has been successfully created!"
            );
            // this.$emit("close");

            // this.resetForm();

            console.log("demoResponse", response);
          }
        };

        this.loader = true;

        const errorHandler = (error) => {
          console.log(error.response);
          this.loader = false;
          this.showToast("Something went wrong internally!", "error", 10000);
        };

        const data = {
          name: this.querryForm.name,
          phone_number: this.querryForm.phone_number,
          email_id: this.querryForm.email,
          query: this.querryForm.query,
          brand_name: this.querryForm.brand_name,
          identifier: "business_suit_demo",
        };
        if (data.query.length == 0) {
          delete data.query;
        }

        this.requestPOST(
          API_URL.requestDemo,
          data,
          {},
          successHandler,
          errorHandler
        );
      }
    },
    // resetForm() {
    //   this.querryForm.brand_name = "";
    //   this.querryForm.email = "";
    //   this.querryForm.name = "";
    //   this.querryForm.phone_number = "";
    //   this.querryForm.query = "";
    // },
    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mainDiv {
  display: flex;
  gap: 33px;
}
.image {
  width: 50%;
  display: flex;
  justify-content: center;
}

.formDiv {
  width: 50%;
}
.showToasterror {
  font-size: 12px;
  color: red;
  margin: 0px;
  transform: translateY(-12px);
}
.backgroundimage {
  width: 220px;

  position: absolute;
}
.textField {
  background: #f8f9f8;
  outline: none;
  height: 54px;
  text-decoration: none;
  margin-bottom: 30px;
  border: none;
  width: 80%;
}

.buttonDiv {
  width: 89.5%;
  height: 54px;
}
.buttonDivdisabled {
  width: 89.5%;
  height: 54px !important;
}
.submitButtonText {
  margin-bottom: 0px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */

  color: #ffffff;
}
.headerText {
  font-weight: 400;
  font-size: 32px;
  position: relative;

  color: #3a3f3a;
  margin-bottom: 55px;
  margin-top: 10px;
}
@media all and (max-width: 1024px) {
  .mainDiv {
    flex-direction: column;
    justify-content: center;
    display: flex;
  }
}
@media all and (max-width: 1024px) {
  .image {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
}
@media all and (max-width: 1024px) {
  .formDiv {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
@media all and (max-width: 1024px) {
  .textField {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
@media all and (max-width: 1024px) {
  .formmainDiv {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
@media all and (max-width: 1024px) {
  .buttonDiv {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 10px;
    box-shadow: 3px 3px 11px rgba(254, 254, 254, 0.33);
  }
}
@media all and (max-width: 1024px) {
  .buttonDivdisabled {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 10px;
  }
}
@media all and (max-width: 1024px) {
  .headerText {
    margin-bottom: 50px;
    font-size: 20px;
    margin-top: 20px;
    // text-align: center;
  }
}
@media all and (max-width: 1024px) {
  .imageMobile {
    max-width: 320px;
    max-height: 320px;
  }
}
</style>
